import { Button } from '../../../shared/components/ui/button'
import AuthBgWrapper from '@/features/auth/components/auth-bg-wrapper'
import AuthCardWrapper from '@/features/auth/components/auth-card-wrapper'
import { successCheckIconSvg, successScreenBgImage } from '@/features/auth/constants/image'
import Image from 'next/image'
import React from 'react'

function SuccessPage() {
    return (
        <AuthBgWrapper image={successScreenBgImage}>
            <AuthCardWrapper
                headerTitle='Successfully Created!'
                headerDescription='Your account has been created.'
                hideLogo
                beforeChildren={
                    <Image 
                        src={successCheckIconSvg}
                        alt='Success Check Icon'
                        className='w-[100px] -mb-5'
                    />
                }
            >
                <Button className='w-full'>Continue</Button>
            </AuthCardWrapper>
        </AuthBgWrapper>
    )
}

export default SuccessPage